import { IndividualMemberDto } from './member';
import { InstitutionDto } from './institution';
import { ChangeRequest } from './changeRequest';

export interface AdminStatistics {
  totalMembers: number;
  totalInstitutions: number;
  pendingRequests: number;
  pendingFieldChanges?: number;
  totalUsers: number;
  pendingRegistrationPetitions: number;
  pendingMemberPetitions: number;
  pendingPayments: number;
  totalRevenueYtd: number;
  /** @deprecated use pendingRequests */
  pendingChangeRequests?: number;
  activeMembers?: number;
  activeInstitutions?: number;
}

export interface AdminMemberListParams {
  page?: number;
  pageSize?: number;
  search?: string;
  membershipType?: number;
  isActive?: boolean;
  vignetteStatus?: number;
  vignetteYear?: number;
}

export interface AdminInstitutionListParams {
  page?: number;
  pageSize?: number;
  search?: string;
  membershipCategory?: number;
  isActive?: boolean;
}

export type AdminEntity = IndividualMemberDto | InstitutionDto;
export type AdminEntityType = 'member' | 'institution';

/** Registration application status: 1=Pending, 2=Approved, 3=Rejected, 4=NeedsChanges */
export type RegistrationApplicationStatus = 1 | 2 | 3 | 4;

/** String names matching backend JsonStringEnumConverter for review payloads */
export type RegistrationReviewStatusName =
  | 'Pending'
  | 'Approved'
  | 'Rejected'
  | 'NeedsChanges';

export const RegistrationStatus = {
  Pending: 1 as RegistrationApplicationStatus,
  Approved: 2 as RegistrationApplicationStatus,
  Rejected: 3 as RegistrationApplicationStatus,
  NeedsChanges: 4 as RegistrationApplicationStatus,
};

export const RegistrationReviewStatus = {
  Pending: 'Pending' as RegistrationReviewStatusName,
  Approved: 'Approved' as RegistrationReviewStatusName,
  Rejected: 'Rejected' as RegistrationReviewStatusName,
  NeedsChanges: 'NeedsChanges' as RegistrationReviewStatusName,
};

export interface RegistrationPetition {
  id: string;
  type: 'Individual' | 'Institution';
  applicationReferenceNumber: string;
  applicantName: string;
  email: string;
  submittedAt: string;
  status: RegistrationApplicationStatus | string;
}

export interface RegistrationPetitionDocument {
  id: string;
  userId: string;
  entityType: number | string;
  entityId: string;
  documentType: number | string;
  fileName: string;
  originalFileName: string;
  fileSize: number;
  contentType: string;
  uploadedAt: string;
  isVerified: boolean;
}

export interface RegistrationPetitionDetail {
  id: string;
  type: 'Individual' | 'Institution';
  applicationReferenceNumber: string;
  status: RegistrationApplicationStatus | string;
  submittedAt: string;
  reviewedAt?: string;
  adminFeedback?: string;
  /** Login email from Users (may differ from profile contact email). */
  accountEmail?: string;
  individual?: IndividualMemberDto;
  institution?: InstitutionDto;
  documents: RegistrationPetitionDocument[];
}

export interface PagedRegistrationPetitions {
  items: RegistrationPetition[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ReviewPetitionRequest {
  status: RegistrationReviewStatusName;
  rejectionReason?: string;
}
